class HeroSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.splide = null;
  }

  connectedCallback() {
    if (typeof Splide === "undefined") {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }

    this.initSplide();
  }

  initSplide() {
    const sliderElement = this.querySelector(".hero-slider__splide");

    if (!sliderElement) {
      return;
    }

    const slides = sliderElement.querySelectorAll(".splide__slide");

    if (slides.length === 0) {
      return;
    }

    if (sliderElement.classList.contains("is-initialized")) {
      const existingSplide = sliderElement.splide;
      if (existingSplide) {
        try {
          existingSplide.destroy();
        } catch (e) {}
      }
      sliderElement.classList.remove("is-initialized", "is-overflow");
      sliderElement.removeAttribute("id");
      sliderElement.removeAttribute("role");
    }

    try {
      const isSingleSlide = slides.length === 1;

      const splideConfig = {
        type: "slide",
        perPage: 1,
        perMove: 1,
        gap: 0,
        padding: 0,
        autoplay: !isSingleSlide,
        interval: 5000,
        pagination: !isSingleSlide,
        arrows: false,
        drag: !isSingleSlide,
        flickPower: 600,
        speed: 600,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        height: "700px",
        keyboard: false,
        wheel: false,
        live: false,
        rewind: true,
        rewindSpeed: 600,
        start: 0,
      };

      this.splide = new Splide(sliderElement, splideConfig);

      this.splide.mount();

      setTimeout(() => {
        this.splide.go(0);
      }, 100);

      sliderElement.heroSliderSplide = this.splide;
    } catch (error) {}
  }

  disconnectedCallback() {
    if (this.splide) {
      try {
        this.splide.destroy();
      } catch (e) {}
    }
  }
}

if (!customElements.get("hero-slider-component")) {
  customElements.define("hero-slider-component", HeroSliderComponent);
}
